
interface GalleryImage {
  id: string;
  url: string;
  category: string;
  uploadedAt: Date;
}

interface GalleryGridProps {
  images: GalleryImage[];
  onImageClick: (index: number) => void;
  onDelete?: (id: string) => void;
}

export default function GalleryGrid({ images, onImageClick, onDelete }: GalleryGridProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {images.map((image, index) => (
        <div
          key={image.id}
          className="relative group aspect-[4/3] rounded-xl overflow-hidden bg-gray-100 cursor-pointer shadow-sm hover:shadow-xl transition-all duration-300"
          onClick={() => onImageClick(index)}
        >
          <img
            src={image.url}
            alt={`Gallery ${index + 1}`}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

          {onDelete && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                if (confirm('이 사진을 삭제하시겠습니까?')) {
                  onDelete(image.id);
                }
              }}
              className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-white/90 hover:bg-red-500 text-gray-700 hover:text-white rounded-full opacity-0 group-hover:opacity-100 transition-all duration-300 cursor-pointer shadow-lg"
            >
              <i className="ri-delete-bin-line text-base"></i>
            </button>
          )}

          <div className="absolute bottom-4 left-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <div className="w-11 h-11 flex items-center justify-center bg-white/90 rounded-full shadow-lg">
              <i className="ri-zoom-in-line text-xl text-gray-900"></i>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
